import { Component } from '@angular/core';

/**
 * rendu de la pop de confirmation
 */
@Component({
  selector: 'connect-item-renderer',
  templateUrl: './connect-item-renderer.html'
})
export class ConnectItemRenderer {
  public desc: string = null; // Description de l'élément
  public icon: any = null; // Icone de l'élément

  /** La donnée affichée */
  protected _data: any;
  public get data(): any {
    return this.getData();
  }
  public set data(pData: any) {
    this.setData(pData);
  }
  protected getData(): any {
    return this._data;
  }
  protected setData(pData: any): void {
    this._data = pData;
    if (this._data) {
      this.desc = this._data.message;
      this.icon = this._data.icon;
    }
  }
}
